import animatorMixin from '@/mixins/animatorMixin'

import { tween, styler, timeline, easing } from 'popmotion'
import { mapState } from 'vuex'

export default {
    mixins: [animatorMixin],

    computed: {
        ...mapState(['w', 'h']),

        styler() {
            return styler(this.rootElement)
        },

        pathStylers() {
            let ps = []
            this.rootElement
                .querySelectorAll('path')
                .forEach(el => ps.push(styler(el)))
            return ps
        },

        action() {
            return timeline([
                // 3000,
                // {
                //     track: 'logo',
                //     from: { x: 0, opacity: 1 },
                //     to: { x: 0, opacity: 1 },
                //     duration: 2000
                // },
                // 3000,
                {
                    track: 'paths',
                    from: { pathLength: 0 },
                    to: { pathLength: 50 },
                    duration: 4000
                },
                '-2300',
                {
                    track: 'fill',
                    from: { fillOpacity: 0, strokeOpacity: 1 },
                    to: { fillOpacity: 1, strokeOpacity: 0 },
                    ease: easing.linear,
                    duration: 600
                },
                '+2000',
                {
                    track: 'logo',
                    from: { y: 0, opacity: 1 },
                    to: { y: -this.h, opacity: 0 },
                    duration: 1000
                }
            ])
        }
    },

    mounted() {
        this.init()
    },

    methods: {
        init() {
            this.styler.set({ x: 0, opacity: 0 })

            this.pathStylers.forEach(s =>
                s.set({
                    pathLength: 50,
                    stroke: 'white',
                    strokeWidth: 2,
                    fillOpacity: 0
                })
            )
        },

        start() {
            this.action.start({
                update: this.reaction,
                complete: this.complete
            })
        },

        complete() {
            this.$emit('complete', 'logo')
        },

        reaction(v) {
            if (v.logo) {
                this.styler.set(v.logo)
            }

            if (v.paths) {
                this.pathStylers.forEach(s => s.set(v.paths))
            }

            if (v.fill) {
                this.pathStylers.forEach(s => s.set(v.fill))
            }
        }
    }
}
